import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from './createBaseQuery';

export interface IGame {
  coverUrl: string;
  videoCoverUrl: string;
  publicName: string;
  publicDescription: string;
  publicRating: string;
  alias: string;
  tags: string[];
  isPublic: boolean;
  isFree: boolean;
  likesNumber: number;
  hasPhotos: boolean;
  sortingKey: number;
}

export const adminGamesApi = createApi({
  reducerPath: 'adminGamesApi',
  baseQuery: createBaseQuery(),
  endpoints: (builder) => ({
    getGames: builder.query<IGame[], void>({
      query: () => ({
        url: '/admin/games/public',
        method: 'GET',
      }),
    })
  }),
});

export const {
  useGetGamesQuery,
} = adminGamesApi;

